import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EventsComponent } from './events/events.component';
import { EventComponent } from './event/event.component';
import { PurchaseHomeResolver } from './purchase/purchaseHome.resolver';
import {
  AvailableTicketsResolver,
  PublicEventResolver,
} from '../shared/resolvers';

const routes: Routes = [
  {
    path: '',
    component: EventsComponent,
    loadChildren: () => import('../events-browse/events-browse.module').then((mod) => mod.EventsBrowseModule),
  },
  {
    path: ':eventId',
    component: EventComponent,
    resolve: {
      availableTickets: AvailableTicketsResolver,
    },
  },
  {
    path: 'n/:eventUrl',
    component: EventComponent,
    resolve: {
      availableTickets: AvailableTicketsResolver,
    },
  },
  {
    path: ':eventId/achat',
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    resolve: {
      purchaseHome: PurchaseHomeResolver,
    },
    loadChildren: () => import('./purchase/purchase.module').then((mod) => mod.PurchaseModule),
  },
  {
    path: 'n/:eventUrl/achat',
    runGuardsAndResolvers: 'pathParamsChange',
    resolve: {
      purchaseHome: PurchaseHomeResolver,
    },
    loadChildren: () => import('./purchase/purchase.module').then((mod) => mod.PurchaseModule),
  },
  {
    path: ':eventId/vente',
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    resolve: {
      event: PublicEventResolver,
    },
    loadChildren: () => import('./sale/sale.module').then((mod) => mod.SaleModule),
  },
  {
    path: 'n/:eventUrl/vente',
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    resolve: {
      event: PublicEventResolver,
    },
    loadChildren: () => import('./sale/sale.module').then((mod) => mod.SaleModule),
  },
  {
    path: 'n/:eventUrl/vente2',
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    resolve: {
      event: PublicEventResolver,
    },
    loadChildren: () => import('./saleV2/saleV2.module').then((mod) => mod.SaleModuleV2),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlatformRoutingModule { }
